
import './Dialogue.css';
import { useEffect, useRef, useState } from 'react';
import Cookie from 'js-cookie';
import axios from "axios";
import { useToast } from '../../CustomeHooks/useToast';
import { getUserFromCookie, isValidToken, getJobCategories } from '../../Javascript_Functions_to_export/Utils';
import MultiSelect from '../Multi_Select_Option_Sets/MultiSelect';
import validator from 'validator';

import e from 'cors';

const Dialogue = ({ message, 
                    closeFn, 
                    contBgColor, 
                    AcceptFn, 
                    planType = 1, 
                    _totalWhatsappNb, 
                    maxCat, 
                    // _phoneNumber,
                    currCandidate }) => {

    const whishIcon = "data:@file/png;base64,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";
    const OMT_Icon = "data:@file/png;base64,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";

    
    // Changing anything in this array, 
    // needs to change it in the "Utils.js" file (in "getJobCategories()" function) as well
    const ss = [
        //{ Id: 0, Name: 'Select a Category', ImageURL : '' },
        //{ Id: 10, Name: 'Accountant', ImageURL : '' },
        { Id: 10, Name: 'Accounting', ImageURL : '' },
        { Id: 20, Name: 'Agriculture', ImageURL : '' },
        { Id: 30, Name: 'Art', ImageURL : '' },
        { Id: 40, Name: 'Business', ImageURL : '' },
        { Id: 50, Name: 'Communications', ImageURL : '' },
        { Id: 60, Name: 'Community and Social Services', ImageURL : '' },
        { Id: 70, Name: 'Construction', ImageURL : '' },
        { Id: 80, Name: 'Education', ImageURL : '' },
        { Id: 90, Name: 'Engineering', ImageURL : '' },
        { Id: 100, Name: 'Farming', ImageURL : '' },
        { Id: 110, Name: 'Finance', ImageURL : '' },
        { Id: 120, Name: 'Food and Serving Related', ImageURL : '' },
        { Id: 130, Name: 'Government', ImageURL : '' },
        { Id: 140, Name: 'Health care', ImageURL : '' },
        { Id: 150, Name: 'Human Resources', ImageURL : '' },
        { Id: 160, Name: 'Information technology', ImageURL : '' },
        { Id: 170, Name: 'Journalist', ImageURL : '' },
        { Id: 180, Name: 'Law', ImageURL : '' },
        { Id: 190, Name: 'Management', ImageURL : '' },
        { Id: 200, Name: 'Manufacturing', ImageURL : '' },
        { Id: 210, Name: 'Marketing', ImageURL : '' },
        { Id: 220, Name: 'Other', ImageURL : '' },            
        { Id: 230, Name: 'Sales', ImageURL : '' },
        { Id: 240, Name: 'Transportation', ImageURL : '' },
    ];

    const [step, setStep] = useState(currCandidate.Category ? 3 : 1);
    const _planType = useRef(planType);
    const totalWhatsappNb = useRef(_totalWhatsappNb);

    const toast = useToast();
    
    // Step 1 states.
    //const [countryId, setCountryId] = useState(0);
    //const [countryIdMessage, setCountryIdMessage] = useState("");
    
    //const [phoneNumber, setPhoneNumber] = useState(_phoneNumber);
    const [phoneNumber, setPhoneNumber] = useState(currCandidate.PhoneNumber ? currCandidate.PhoneNumber : "");
    const [subscriptionEmail, setSubscriptionEmail] = 
        useState(currCandidate.SubscriptionEmail ? currCandidate.SubscriptionEmail : "");
    
    const [categories, setCategories] = useState();

    const fetchCategoriesByIDs = (IdsCommaSeparated) => {
        if(!IdsCommaSeparated || IdsCommaSeparated.trim() == "")
            return [];

        var selCategories = [];
        var ids = IdsCommaSeparated.split(",");
        for (let index = 0; index < ids.length; index++) {
            var categoryItem = ss.find(c => c.Id == ids[index]);
            if(categoryItem) {
                selCategories.push(categoryItem);
            }
        }
        return selCategories;
    }

    const [selectedCategories, setSelectedCategories] = useState(fetchCategoriesByIDs(currCandidate.Category));

    // Step 2 states.
    const [sendingCode, setSendingCode] = useState(false);
    const [checkingCode, setCheckingCode] = useState(false);

    const [code, setCode] = useState("");

    useEffect(() => {
        setCategories(getJobCategories());
        //console.log("categories=", getJobCategories());
    }, []);

    const _closeDialog = () => {
        setSelectedCategories([]);
        closeFn(true);
    }

    //const lebRegex = /^d{2}[\s][/][\s]d{3}[\s]d{3}$/;
    const lebRegex = /^\d{2}[\s][/][\s]\d{3}[\s]\d{3}$/;

    // https://medium.com/@akmuthumala/forgot-and-reset-password-using-nodejs-with-email-otp-57c11514317e
    axios.defaults.withCredentials = true;
    const sent6DigitsCodeToUser = () => {
        //e.preventDefault();

        if(!subscriptionEmail || subscriptionEmail.trim() == "") {
            //toast("error", "'Phone' is required");
            toast("error", "'Email' is required");
            return;
        }

        if(!validator.isEmail(subscriptionEmail)) {
            toast("warning", "Invalid Email !");
            return;
        }

        setSendingCode(true);
        
        axios.post(`${process.env.REACT_APP_URL}/set6DigitsCode`, { 
            //countryCode: "+961",
            //phoneNumber: phoneNumber,
            subscriptionEmail: subscriptionEmail,
            candidateId: getUserFromCookie(Cookie.get('token')).ID,
            candidateUsername: getUserFromCookie(Cookie.get('token')).Username,
            newCode: false,
            
            //planType: _planType.current,
            //categoryId: names.join(", "),
        })
        .then(res => {
            if(res.data.status === 'success') {
                setStep(step + 1);
                setCode("");
                toast("success", "Your 6 digits code has been sent.");
                // for (let index = 0; index < 3000000000; index++) {
                //     var i = 45;
                // }
            }
            else
                toast("error", res.data.message);
        })
        .catch(err => {
            console.log("err=", err);
        })
        .finally(() => {
            setSendingCode(false);
        });
        
        //if(lebRegex.test(phoneNumber)) {
        //}
        //else
            //console.log("false")
        
    }

    const backToBeginning = () => {
        setStep(1);
    }

    //To confirm that you own the phone number, you'll be prompted to enter a 6-digit registration code sent to you via SMS or phone call. Note: You can get a registration code through email if you are re-registering and have previously set up two-step verification with an email address.
    const back = () => {
        setStep(step - 1);
    }

    // https://medium.com/@akmuthumala/forgot-and-reset-password-using-nodejs-with-email-otp-57c11514317e
    axios.defaults.withCredentials = true;
    const checkCode = (e) => {

        if(!code || code.trim() == "") {
            toast("error", "Code is required !");
            return;
        }

        if(code.trim().length !== 7) {
            toast("error", "'Code' should be 6 digits");
            return;
        }

        if(isNaN(code.replaceAll(" ", "").trim())) {
            toast("error", "'Code' should contains only numbers");
            return;
        }

        setCheckingCode(true);

        axios.post(`${process.env.REACT_APP_URL}/checkIfCodeMatches`, {
            candidateId: getUserFromCookie(Cookie.get('token')).ID,
            code: code.replaceAll(" ", ""),
        })
        .then(res => {
            if(res.data.status === 'success') {
                // The candidate send the code and it's matching.
                // So go to the third step in this case.
                setStep(3);
            }
            else
                toast("error", res.data.message);
        })
        .catch(err => {
            console.log("err", err);
        })
        .finally(() => {
            setCheckingCode(false);
        })


        //AcceptFn();
    }

    // https://jsfiddle.net/d2f2z937/
    function formatWithPlaceholder(text, values){
        values = values.toString();
        var pattern = /\{\{|\}\}|{(\d+)}/g;
        var formattedString = text.replace(pattern, function(match, group){
            var value;
            if(match === "{{"){
                return "{";
            }
             if(match === "}}"){
                 return "}";
            }
            value = values[parseInt(group, 10)];
            return value ? value.toString() : "";
        });
        return (values.length > 0) ? formattedString : "";
    }

    const countries = [
        { Id: "0", Name: "Country Code", PhoneCode: "", Pattern: "xx xxx xxxx" },
        { Id: "1", Name: "KSA", PhoneCode: "+966", Pattern: "xx xxx xxxx" },
        { Id: "2", Name: "LEB", PhoneCode: "+961", Pattern: "xx xxx xxx" },
    ];

    function formatString(value, pattern) {
        let i = 0;
        return pattern.replace(/#/g, () => value[i++] || "");
    }

    const _setCode = (e) => {
        if(e && e.target) {
            var valueWithoutFormat = e.target.value.replaceAll(" ", "");//.replaceAll("/","");
            var finalVal = formatWithPlaceholder("{0}{1}{2} {3}{4}{5}", valueWithoutFormat);
            if(finalVal.substring(finalVal.length - 1) === " ")
                finalVal = finalVal.trim();
            setCode(finalVal);
        }
    }

    const onChangePhoneNumber = (e) => {
        if(e && e.target) {
            //setPhoneNumber(e.target.value);
            //return;

            var valueWithoutFormat = e.target.value.replaceAll(" ", "");//.replaceAll("/","");
            var finalVal = formatWithPlaceholder("{0}{1} {2}{3}{4} {5}{6}{7}", valueWithoutFormat);
            if(finalVal.substring(finalVal.length - 1) === " ")
                finalVal = finalVal.trim();
            setPhoneNumber(finalVal);

            return;
            // if(!e.target.value || e.target.value.trim == "")
            //     setPhoneMessage("Required field !");
            // else
            //     setPhoneMessage("");

            var phoneNumber = e.target.value.replaceAll(" ", "");
            const formattedCard = formatString(phoneNumber, "#### #### #### ####");
            setPhoneNumber(formattedCard);
            return;

            var phoneNumber = e.target.value.replaceAll(" ", "");
            var formatted = phoneNumber.replace(/(\d{2})(\d{3})(\d{3})/, "($1) $2 $3");
            setPhoneNumber(formatted);
            return;

            var lastEnteredChar = e.target.value.substring(e.target.value.length - 1);
            
            var inputValue = e.target.value.replaceAll(" ", "");

            var arr = Array.from(inputValue);
            arr.splice(2, 0, " ");
            arr.splice(6, 0, " ");
            inputValue = arr.toString().replaceAll(",", "");

            if(
                !(lastEnteredChar == "0" || lastEnteredChar == "1" || lastEnteredChar == "2" || 
                lastEnteredChar == "3" || lastEnteredChar == "4" || lastEnteredChar == "5" || 
                lastEnteredChar == "6" || lastEnteredChar == "7" || lastEnteredChar == "8" || 
                lastEnteredChar == "9")
            ) {
                inputValue = e.target.value.substring( 0, e.target.value.length - 1);
            }
            else if(lastEnteredChar === " ") {
                e.target.value.substring( 0, e.target.value.length - 2);
            }

            var format = "xx x xx xxx";
            //var valueWithoutFormat = inputValue.replaceAll(" ", "");
            var phoneLength = inputValue.length;
            
            if(format[phoneLength] === " ") {
                //inputValue += " ";
            }           
            setPhoneNumber(inputValue);

            return;

            //var src = /^(\d{3})(\d{4})(\d{5})(\d{1})$/;
            //var dst = '$1 $2 $3 $4';
            //return str.replace(src, dst)
            //alert(e.target.value.replace(src, dst));
            //alert(e.target.value.replace(src, /^(\d{3})[ ](\d{4})[ ](\d{5})[ ](\d{1})$/));
            //11 111 111
            //debugger;
            var valueWithoutFormat = inputValue.replaceAll(" ", "");//.replaceAll("/","");
            var finalVal = formatWithPlaceholder("{0}{1} {2}{3}{4} {5}{6}{7}", valueWithoutFormat);
            if(finalVal.substring(finalVal.length - 1) === " ")
                finalVal = finalVal.trim();
            setPhoneNumber(finalVal);
        }
    }

    // const _setCountryId = (e) => {
    //     if(e && e.target) {
    //         setCountryId(e.target.value);
    //         if(parseInt(e.target.value) > 0)
    //             setCountryIdMessage("");
    //     }
    // }

    // const _setCategoryItem = (e) => {
    //     if(e && e.target) {
    //         setCategoryItem(e.target.value);
    //         if(parseInt(e.target.value) > 0)
    //             setCategoryMessage("");
    //     }
    // }

    const [paymentMethod, setPaymentMethod] = useState("");

    const changePayMethod = (_val) => {
        setPaymentMethod(_val);
    }

    const acceptCategories = () => {
        
        if(!selectedCategories || selectedCategories.length === 0) {
            toast("error", "No category is selected");
            return;
        }

        setStep(step + 1);
    }


    const sendAnotherCode = () => {
        setCheckingCode(true);

        //axios.post(`${process.env.REACT_APP_URL}/resetWhatsAppCode`, {    // old code
        axios.post(`${process.env.REACT_APP_URL}/set6DigitsCode`, {      // new code
            candidateId: getUserFromCookie(Cookie.get('token')).ID,
            subscriptionEmail: subscriptionEmail,
            candidateUsername: getUserFromCookie(Cookie.get('token')).Username,
            newCode: true,
        })
        .then(res => {
            if(res.data.status === 'success') {
                toast("success", "A new code has been sent");
                // for (let index = 0; index < 50000000; index++) {
                //     const element = 50000000;
                // }
            }
            else
                toast("error", res.data.message);
        })
        .catch(err => {
            console.log("err=", err);
        })
        .finally(() => {
            setCheckingCode(false);
        });
    }


    const getSelectedCategoriesIDs = (_selCategories) => {
        // Get the selected categories Ids (_Ids: comma separated).
        //alert(_Ids);
        setSelectedCategories(_selCategories);
        //setRemainingNb(maxCat - _selCategories.length);
    }

    const [isSending, setIsSending] = useState(false);
    const [status, setStatus] = useState(1);
    const sendMessageToMe = () => {
        
        if(!paymentMethod || paymentMethod.trim() == "") {
            toast("error", "'Payment Method' is required !");
            return;
        }

        if(!phoneNumber || phoneNumber.trim() == "") {
            toast("error", "'Phone' is required !");
            return;
        }
        
        if(phoneNumber.trim().length !== 10) {
            toast("error", "'Phone' should be 8 digits !");
            return;
        }

        if(isNaN(phoneNumber.replaceAll(" ", "").trim())) {
            toast("error", "'Phone' should contains only numbers !");
            return;
        }

        const names = selectedCategories.reduce((cat, obj) => {
            cat.push(obj.Id);
            return cat;
        }, []);

        var newContactMessage = {
            planType: _planType.current,
            categories: "," + names.join(",") + ",".replaceAll(" ", "").trim(),
            totalWhatsappNb: totalWhatsappNb.current,
            phoneNumber: phoneNumber,
            Id: getUserFromCookie(Cookie.get('token')).ID,
            userName: getUserFromCookie(Cookie.get('token')).Username,
            paymentMethod: paymentMethod.toLocaleLowerCase().trim(),
        }
        
        setIsSending(true);
        axios.defaults.withCredentials = true;
        axios.post(process.env.REACT_APP_URL + '/Send_Request', newContactMessage)
        .then((res) => {
            if(res.data.status && res.data.status !== "success") {
                toast('error', res.data.message);
            }
            else {   
                if(res.data.toLowerCase() === 'success') {
                    setStep(step + 1);
                    setSelectedCategories([]);
                    //toast('success', 'Thanks for the subscription ...' );
                    setStatus(1);
                    setTimeout(() => {
                        closeFn(true);
                        //setStep(step - 1);   // added for just modifying the layout.
                    }, 5000);

                }
                else {
                    toast('error', "Error in sending message !");
                }
            }
        })
        .catch((err) => {
            console.log("inside catch", err);
        })
        .finally(() => {
            setIsSending(false);
        });
    }

    const handleSubmit = (e) => {
        e.preventDefault();
    }

return(<div className='dialog-container' style={{ background: contBgColor }}>
            <div className='dialog-box'>

                {/* I add "onSubmit={ handleSubmit }", 
                to prevent any navigation if user was inside an input and presses "Enter" button on keyboard */}
                <form onSubmit={ handleSubmit } className='dialog-form'>
                    <div className='dialog-header'>
                        <div className='first-line' >
                            <div></div>
                            <div className='title'>
                                { 
                                    step === 1 ? "Enter your email" :
                                    step === 2 ? "Enter the code" :
                                    step === 3 ? "Select your categories" :
                                    step === 4 ? "Payment Method" :
                                    "Done"
                                }
                            </div>
                            <div className='close-btn' 
                                onClick={ _closeDialog }
                                style={{ visibility: step === 5 ? "hidden" : "visible" }}>
                                <svg xmlns="http://www.w3.org/2000/svg" 
                                    viewBox="0 0 384 512"
                                    width="30" height="30">
                                <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>
                            </div>
                        </div>
                        <div className='verif-steps'>
                            {/* Add icons instead of divs, to let user knows about all steps meaning */}
                            <i className={`fa fa-at step1 ${ step == 1 ? "current" : step > 1 ? "active" : "" } `} 
                                aria-hidden="true"></i>
                            <div style={{ width: "120px", height: "2px", background: step >= 2 ? "#3ad33a" : "#eeeeee" }}>

                            </div>
                            {/* <div className= {` step1 ${ step == 1 ? "current" : step > 1 ? "active" : "" } `}>
                            </div> */}
                            <div className= {` step2 ${ step == 2 ? "current" : step > 2 ? "active" : "" } `}>
                                ******
                            </div>
                            <div style={{ width: "120px", height: "2px", background: step >= 3 ? "#3ad33a" : "#eeeeee" }}>

                            </div>
                            <i className={`fa fa-th-large step3 ${ step == 3 ? "current" : step > 3 ? "active" : "" } `} 
                                aria-hidden="true"></i>
                            {/* <div className= {` step3 ${ step == 3 ? "current" : step > 3 ? "active" : "" } `}>
                            </div> */}
                            <div style={{ width: "120px", height: "2px", background: step >= 4 ? "#3ad33a" : "#eeeeee" }}>

                            </div>
                            <i className={`fa fa-usd step4 ${ step == 4 ? "current" : step > 4 ? "active" : "" } `} 
                                aria-hidden="true"></i>
                            {/* <div className= {` step4 ${ step == 4 ? "current" : step > 4 ? "active" : "" } `}>
                            </div> */}
                            {/* <div className= {` step2 ${ step >= 2 ? "active" : "" } `}></div>
                            <div className= {` step3 ${ step == 3 ? "active" : "" } `}></div> */}
                        </div>
                    </div>
                    
                    
                    <div className='dialog-body'>
                        { step === 1 ? 
                        // { step === 3 ? Send My Request (to send me a message) otherwise the subscription stills inactive
                                     
                        <div className='second-line'>
                            <div className='enter-phone'>
                                { message } <span style={{ color: "red" }}>*</span>
                            </div>
                            <div className='flag-line'>
                                <input name='email'
                                    className='email-field'
                                    type='text'
                                    placeholder='my_personal@email.com'
                                    autoComplete='off'
                                    value={ subscriptionEmail }
                                    onChange={ e => setSubscriptionEmail(e.target.value) }
                                    maxLength= "50" />
                                     {/* _ {subscriptionEmail} */}
                            </div>
                        </div>
                        
                        : step === 2 ?
                        <>
                            <div className='second-line'>
                                {/* We sent your code to: +******52.<br /><br/> */}
                                {/* Please check your phone for a whatsapp message with your code.<br/> */}
                                Please check your email for a message with your code,
                                your code is 6 digits long.
                                    <input name="whatsappCode"
                                        className='whatsapp-code' 
                                        type='text'
                                        autoComplete='off'
                                        placeholder='--- ---'
                                        value={ code }
                                        onChange={ _setCode }
                                        maxLength='7' />

                                {/* This code will expire in 1 minute. */}
                            </div>
                            <div>
                                I didn't receive the code, 
                                <span className='send-another'
                                    onClick={ sendAnotherCode }>
                                    &nbsp;<u><i>send me another one.</i></u>
                                </span>
                                <div>
                                    If you are not receiving any code, please try to change your email address.
                                </div>
                            </div>
                        </>
                        : step === 3 ?
                        <>
                            <div className='third-line'>
                                {/* <div className='category-line'>
                                    Categor{ parseInt(planType) === 1 ? 'y' : 'ies' }: <span style={{ color: "red" }}>*</span>
                                </div> */}
                                <div className='component-line'>
                                    {/* I want to be notified for the : */}

                                    <MultiSelect availText="Select Categories"
                                                // SelectedText={`Notify me for : ${ remainingNb } categories`}
                                                lsElements={ ss }
                                                onChangeSelection={ getSelectedCategoriesIDs }
                                                _selectedCategories = { selectedCategories }
                                                maxCategories= { maxCat } />
                                </div>
                                {/* <div className='phone-message'>
                                    { categoryMessage }
                                </div> */}
                            </div>
                        </>
                        : step === 4 ? 
                        <div className='send-money'>
                            {/* <div>Choose a way to send money to 78/828 895 phone number:</div> */}
                            <div>I will send money to 78/828 895 via:</div>
                            
                            <div className='payment-methods'>
                            
                                <div className='single-line'>
                                    <input type="radio" 
                                        id="omt"  
                                        name="paymentmethod"
                                        value="omt" 
                                        checked={ paymentMethod.toLowerCase() === "omt" }
                                        onChange={ (e) => changePayMethod(e.target.value) }/>

                                    <label htmlFor="omt" className='icon-label'>
                                        <img src={ OMT_Icon } 
                                            alt="Whish"
                                            style={{ width:"30px", height:"30px", borderRadius:"50%" }}  />
                                    </label>
                                </div>
                                <div className='single-line'>
                                    <input type="radio" 
                                        id="wish"  
                                        name="paymentmethod" 
                                        value="wish"
                                        checked={ paymentMethod.toLowerCase() === "wish" }
                                        onChange={ (e) => changePayMethod(e.target.value) }/>
                                    <label htmlFor="wish" className='icon-label'>
                                        <img src={ whishIcon } 
                                            alt="Whish"
                                            style={{ width:"30px", height:"30px", borderRadius:"50%" }}  />
                                    </label>
                                </div>

                                {/* <div>or Pay via your Credit Card:</div> */}
                                {/* <div className='single-line'>
                                    <input type="radio" 
                                        id="card"  
                                        name="paymentmethod" 
                                        value="card"
                                        checked={ paymentMethod.toLowerCase() === "card" }
                                        onChange={ (e) => changePayMethod(e.target.value) }/>
                                    <label htmlFor="card" className="label-3 icon-label">
                                        <i className="fa fa-credit-card-alt" aria-hidden="true"></i>
                                    </label>
                                </div> */}
                            </div>

                            <div className='phone-number-line'>
                                <div>using</div> 
                                <div className='flag-line'>
                                    <div className='flag-and-code'>
                                        <img src="https://flagcdn.com/lb.svg" 
                                                alt="leb_flag" 
                                                className='flag' />
                                    </div>
                                    <div>
                                        +961
                                    </div>
                                </div>
                                <input name='phone'
                                    className='phone-field'
                                    type='text'
                                    placeholder='71 123 456'
                                    autoComplete='off'
                                    value={ phoneNumber }
                                    onChange={ onChangePhoneNumber }
                                    maxLength= "10" />&nbsp;phone number.
                            </div>
                            {/* 2 - Send your request to confirm it . */}
                        </div>
                        :
                        <div className='thanks-message'>
                            Thank you for your subscription.
                        </div>
                        }
                    </div>

                    <div className='dialog-footer'>
                        { 
                            step === 1 ? 
                            <div className='buttons'>
                                
                                <input type='button'
                                        className={`${ sendingCode ? 'disabled' : ''} btn-verify-code primary`}
                                        disabled = { sendingCode }
                                        onClick={ e => sent6DigitsCodeToUser(e) } 
                                        value="Verify Email"/>
                                        {/* Verify Number */}
                                        {/* Verify Email */}
                                {/* </button> */}

                                
                                        {/* <button type='button' className='button success'>Next</button>
                                        <button type='button' className='button danger'>Back</button> */}
                            </div>
                            
                            : step === 2 ?
                            <div className='buttons'>
                                <button type='button' 
                                        className='btn secondary'
                                        onClick={ back }>Back</button>
                                
                                <button type='button' 
                                    // className='btn success'
                                    className={`${ checkingCode ? 'disabled' : ''} btn success`}
                                    onClick={ checkCode }>
                                    Check Code
                                </button>
                            </div>
                            : step === 3 ?
                            <div className='buttons'>
                                <button type='button' 
                                        className='btn primary btn-wide'
                                        onClick={ backToBeginning }>Change My Email</button>
                                <button type='button' 
                                        className={ `btn success ${ selectedCategories.length > maxCat ? "disabled" : "" } `}
                                        disabled={ selectedCategories.length > maxCat }
                                        onClick={ acceptCategories }>Accept</button>
                            </div>
                            : step === 4 ?
                            <div className='buttons'>
                                <button type='button' 
                                        name='backToStep2'
                                        className='btn secondary'
                                        onClick={ back }>
                                    Back
                                </button>
                                <button type='button'
                                        className='btn success btn-wide' 
                                        name='btnSendMessage'
                                        onClick={ sendMessageToMe }>
                                    Send my request
                                </button>
                            </div>
                            :
                            <></>
                        }
                    </div>
                </form>
            </div>
    </div>)
}

export default Dialogue;